module.exports = __webpack_public_path__ + "img/vehicle-test-04.06c02677.jpeg";